import { render, staticRenderFns } from "./CambioPassword.vue?vue&type=template&id=28b19cc5&scoped=true&"
import script from "./CambioPassword.vue?vue&type=script&lang=ts&"
export * from "./CambioPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b19cc5",
  null
  
)

export default component.exports